import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {map, Observable} from "rxjs";

@Component({
    selector: 'app-edit-processing-fee',
    templateUrl: './edit-processing-fee.component.html',
    styleUrls: ['./edit-processing-fee.component.scss']
})
export class EditProcessingFeeComponent implements OnInit {

    constructor(public formBuilder: FormBuilder, public dialogRef: MatDialogRef<EditProcessingFeeComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        let data = {
            administrationFees: this.data.administrationFees,
            packingFees: this.data.packingFees,
            portFees: this.data.portFees,
            vatPercentage: this.data.vatPercentage
        }
        this.dialogRef.close(data);
    }
}
